import styled from "styled-components"
import { getCssSizeValue, getHtmlFromRedactorField, isStringEmpty } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Image, { formatImageCMSData } from "@/components/common/Image"
import { BUTTON_VARIANTS, WHO_HELPS_VARIANTS } from "@/constants"
import { getButtonLinkData } from "@/components/common/Buttons/Button"
import LinkButton from "@/components/common/Buttons/LinkButton"

export const SIZE_VARIANTS = {
	SMALL: "Small",
	LARGE: "Large",
}

const StyledWrapper = styled.div`
	direction: ltr;
	border: 1px solid ${(props) => props.theme.colors.richBlack};
	display: flex;
	flex-direction: column;
	//aspect-ratio: 335/262;
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	.button {
		margin-top: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-bottom: unset;
		//aspect-ratio: 470/352;
		padding: ${getCssSizeValue(16, BREAKPOINTS.TABLET)};
		.button {
			margin-top: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		//aspect-ratio: 427/356;
		min-height: ${getCssSizeValue(356)};
		padding: ${getCssSizeValue(32)} ${getCssSizeValue(24)} ${getCssSizeValue(32)} ${getCssSizeValue(24)};
		.button {
			margin-top: ${getCssSizeValue(64)};
		}
	}

	.header {
		margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

		@media (min-width: ${({ theme }) => theme.breakpoints.tablet || 768}px) {
			margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.TABLET)};
		}

		@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(20)};
		}
	}

	&.${SIZE_VARIANTS.SMALL}.with-button {
		justify-content: space-between;
		gap: ${getCssSizeValue(48)};
	}

	&.${SIZE_VARIANTS.LARGE} {
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			aspect-ratio: unset;

			.header {
				width: 60%;
			}
		}
	}

	&.${SIZE_VARIANTS.LARGE}.with-button {
		justify-content: space-between;
	}
`

const StyledIcon = styled(Image)`
	aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "16/9"};
	width: auto;
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	height: ${getCssSizeValue(80, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet || 768}px) {
		margin-bottom: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		height: ${getCssSizeValue(100)};
		margin-bottom: ${getCssSizeValue(40)};
	}
`

function getDataForPartner(partner) {
	const name = partner?.name || ""
	const description = partner?.description || ""
	const image = formatImageCMSData(partner?.logo || {})

	return {
		name,
		description,
		image,
	}
}

function getData(data) {
	const partner = getDataForPartner(data?.partner || {})
	const button = getButtonLinkData(data?.button)
	const sizeVariant = data?.sizeVariant || SIZE_VARIANTS.SMALL

	return { partner, button, sizeVariant }
}

export default function SinglePartner({ partner, variant }) {
	const { partner: partnerData, button, sizeVariant } = getData(partner)
	const desktopCols = variant !== WHO_HELPS_VARIANTS.MANY || sizeVariant === SIZE_VARIANTS.LARGE ? 8 : 4
	const withButton = isStringEmpty(button.url) ? "" : "with-button"

	return (
		<StyledWrapper className={`col-mobile-8 col-tablet-4 col-desktop-${desktopCols} ${sizeVariant} ${withButton}`}>
			<div>
				<div>
					<StyledIcon
						src={partnerData.image.url}
						alt={partnerData.image.alt}
						sizes={"100vw"}
						$aspectRatio={partnerData.image.aspectRatio}
					/>
				</div>
				<div
					className="typo-strawford typo-strawford-60 header"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(partnerData.name)}
				/>
				<div
					className="typo-strawford typo-strawford-23 description"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(partnerData.description)}
				/>
			</div>
			{!isStringEmpty(button.url) && <LinkButton {...button} variant={BUTTON_VARIANTS.QUATERNARY} />}
		</StyledWrapper>
	)
}
